import React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import { Body } from '@hover/blueprint';

interface Props {
  to: string;
  body: string;
}

const HeroLink: React.FC<Props> = ({ to, body }) => (
  <Body
    d="inline-block"
    _hover={{ textDecoration: 'none' }}
    as={GatsbyLink}
    size={300}
    color="primary.600"
    isSemiBold
    to={to}
  >
    {body}
  </Body>
);

export default HeroLink;
